<aside class="page-aside" style="max-height:calc(100vh - var(--wa-spacing-3x-large));min-width:14rem;overflow-y:auto;padding:0 var(--wa-spacing-large) var(--wa-spacing-large) var(--wa-spacing-large);position:sticky;top:var(--wa-spacing-large);">
	<wa-input (wa-clear)="onFilterChange($event)" (wa-input)="onFilterChange($event)" clearable placeholder="Filter…" size="small" style="margin-bottom:var(--wa-spacing-medium);">
		<wa-icon name="magnifying-glass" slot="start"></wa-icon>
	</wa-input>
	<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>Frameworks & Components</div>
	<wa-tree style="--indent-guide-color:var(--wa-color-neutral-300);--indent-size:12px;">
		<wa-tree-item>
			<a (click)="navigateToFramework('web-awesome')" href="javascript:void(0)" style="cursor:pointer;font-weight:var(--wa-font-weight-semibold);">WebAwesome</a>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Page Shell</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-page')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaPage</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-page-banner')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaPageBanner</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-page-header')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaPageHeader</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-page-sub-header')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaPageSubHeader</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-page-content')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaPageContent</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-page-contents-main')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaPageContentsMain</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-page-contents-main-header')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaPageContentsMainHeader</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-page-contents-main-footer')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaPageContentsMainFooter</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-page-contents-aside')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaPageContentsAside</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-page-contents-navigation')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaPageContentsNavigation</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-page-contents-navigation-header')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaPageContentsNavigationHeader</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-page-contents-navigation-footer')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaPageContentsNavigationFooter</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-page-navigation-toggle')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaPageNavigationToggle</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-page-navigation-toggle-icon')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaPageNavigationToggleIcon</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-page-footer')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaPageFooter</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-page-menu')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaPageMenu</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-page-skip-to-content')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaPageSkipToContent</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-page-dialog-wrapper')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaPageDialogWrapper</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Layout</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-stack')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaStack</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-cluster')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaCluster</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-grid')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaGrid</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-split')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaSplit</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-flank')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaFlank</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-frame')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaFrame</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-div')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaDiv</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-split-panel')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaSplitPanel</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-scroller')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaScroller</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Buttons</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-button')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaButton</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-button-group')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaButtonGroup</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-split-button')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaSplitButton</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-copy-button')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaCopyButton</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-drop-down')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaDropDown</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-dropdown-item')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaDropdownItem</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Cards & Containers</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-card')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaCard</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-callout')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaCallout</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-details')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaDetails</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Navigation</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-breadcrumbs')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaBreadcrumbs</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-breadcrumb-item')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaBreadcrumbItem</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-tab-group')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaTabGroup</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-tab')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaTab</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-tab-panel')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaTabPanel</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-tree')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaTree</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-tree-item')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaTreeItem</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Form Controls</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-input')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaInput</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-number-input')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaNumberInput</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-text-area')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaTextArea</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-select')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaSelect</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-select-option')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaSelectOption</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-checkbox')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaCheckbox</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-radio')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaRadio</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-radio-group')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaRadioGroup</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-switch')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaSwitch</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-range')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaRange</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-color-picker')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaColorPicker</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-rating')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaRating</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-spinner')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaSpinner</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Data Display</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-text')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaText</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-tag')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaTag</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-badge')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaBadge</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-icon')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaIcon</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-avatar')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaAvatar</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-avatar-group')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaAvatarGroup</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-divider')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaDivider</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-qrcode')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaQRCode</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-markdown')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaMarkdown</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Media</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-carousel')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaCarousel</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-carousel-item')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaCarouselItem</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-animated-image')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaAnimatedImage</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-image-compare')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaImageCompare</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-comparison')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaComparison</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-zoomable-frame')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaZoomableFrame</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Overlays & Feedback</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-dialog')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaDialog</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-drawer')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaDrawer</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-tooltip')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaTooltip</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-popover')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaPopover</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-popup')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaPopup</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-toast-container')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaToastContainer</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-toast-item')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaToastItem</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-toast-data-service')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaToastDataService</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Progress & Loading</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-progress-bar')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaProgressBar</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-skeleton')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaSkeleton</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">General</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-progress-ring')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaProgressRing</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-format-bytes')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaFormatBytes</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-format-date')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaFormatDate</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-format-number')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaFormatNumber</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-relative-time')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaRelativeTime</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-include')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaInclude</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-animation')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaAnimation</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-intersection-observer')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaIntersectionObserver</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-mutation-observer')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaMutationObserver</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome', 'wa-resize-observer')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaResizeObserver</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-brand-normal);font-size:var(--wa-font-size-xs);">Related Plugins</span>
				<wa-tree-item>
					<a (click)="navigateToPlugin('fontawesome')" href="javascript:void(0)" style="color:var(--wa-color-brand-normal);cursor:pointer;">Font Awesome</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToPlugin('fontawesome-pro')" href="javascript:void(0)" style="color:var(--wa-color-brand-normal);cursor:pointer;">Font Awesome Pro</a>
				</wa-tree-item>
			</wa-tree-item>
		</wa-tree-item>
		<wa-tree-item>
			<a (click)="navigateToFramework('web-awesome-pro')" href="javascript:void(0)" style="cursor:pointer;font-weight:var(--wa-font-weight-semibold);">WebAwesome Pro</a>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Form Controls</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome-pro', 'wa-combobox')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaCombobox</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome-pro', 'wa-file-input')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaFileInput</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Charts</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome-pro', 'wa-chart')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaChart</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome-pro', 'wa-bar-chart')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaBarChart</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome-pro', 'wa-line-chart')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaLineChart</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome-pro', 'wa-pie-chart')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaPieChart</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome-pro', 'wa-doughnut-chart')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaDoughnutChart</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome-pro', 'wa-bubble-chart')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaBubbleChart</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome-pro', 'wa-scatter-chart')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaScatterChart</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome-pro', 'wa-radar-chart')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaRadarChart</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome-pro', 'wa-polar-area-chart')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaPolarAreaChart</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome-pro', 'wa-sparkline')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaSparkline</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Icons</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('web-awesome-pro', 'wa-icon-fa')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">WaIconFA</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-brand-normal);font-size:var(--wa-font-size-xs);">Related Plugins</span>
				<wa-tree-item>
					<a (click)="navigateToPlugin('chartjs')" href="javascript:void(0)" style="color:var(--wa-color-brand-normal);cursor:pointer;">Chart.js</a>
				</wa-tree-item>
			</wa-tree-item>
		</wa-tree-item>
		<wa-tree-item>
			<a (click)="navigateToFramework('bootstrap')" href="javascript:void(0)" style="cursor:pointer;font-weight:var(--wa-font-weight-semibold);">Bootstrap</a>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Disclosure</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('bootstrap', 'bsaccordion')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">BSAccordion</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('bootstrap', 'bscollapse')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">BSCollapse</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Alerts</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('bootstrap', 'bsalert')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">BSAlert</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Data Display</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('bootstrap', 'bsbadge')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">BSBadge</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('bootstrap', 'bstable')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">BSTable</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">General</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('bootstrap', 'bsbreadcrumb-container')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">BSBreadcrumbContainer</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('bootstrap', 'bsbutton')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">BSButton</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('bootstrap', 'bsbutton-group')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">BSButtonGroup</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('bootstrap', 'bsswitch')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">BSSwitch</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('bootstrap', 'bscard')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">BSCard</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Form Controls</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('bootstrap', 'bscheck-box')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">BSCheckBox</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('bootstrap', 'bsradio-button')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">BSRadioButton</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('bootstrap', 'bsdate-picker')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">BSDatePicker</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('bootstrap', 'bsfile-upload')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">BSFileUpload</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('bootstrap', 'bsform')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">BSForm</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('bootstrap', 'bsrange')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">BSRange</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('bootstrap', 'bsselect')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">BSSelect</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('bootstrap', 'bstime-picker')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">BSTimePicker</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Media</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('bootstrap', 'bscarousel')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">BSCarousel</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('bootstrap', 'bsfigure')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">BSFigure</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('bootstrap', 'bsimage')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">BSImage</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('bootstrap', 'bsmedia')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">BSMedia</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Utilities</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('bootstrap', 'bsclose-icon')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">BSCloseIcon</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('bootstrap', 'bstoggle')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">BSToggle</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Layout</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('bootstrap', 'bscontainer')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">BSContainer</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Navigation</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('bootstrap', 'bsdrop-down')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">BSDropDown</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('bootstrap', 'bsnav-bar')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">BSNavBar</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('bootstrap', 'bsnavs')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">BSNavs</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('bootstrap', 'bspagination')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">BSPagination</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Hero</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('bootstrap', 'bsjumbotron')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">BSJumbotron</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Lists</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('bootstrap', 'bslist-group')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">BSListGroup</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Overlays & Feedback</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('bootstrap', 'bsmodal')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">BSModal</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('bootstrap', 'bspop-over')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">BSPopOver</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('bootstrap', 'bstoast')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">BSToast</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Progress & Loading</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('bootstrap', 'bsprogress-bar')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">BSProgressBar</a>
				</wa-tree-item>
			</wa-tree-item>
		</wa-tree-item>
		<wa-tree-item>
			<a (click)="navigateToFramework('angular-material')" href="javascript:void(0)" style="cursor:pointer;font-weight:var(--wa-font-weight-semibold);">Angular Material</a>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Disclosure</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('angular-material', 'mat-accordion')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">MatAccordion</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Form Controls</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('angular-material', 'mat-auto-complete')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">MatAutoComplete</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('angular-material', 'mat-checkbox')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">MatCheckbox</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('angular-material', 'mat-chip-auto-complete')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">MatChipAutoComplete</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('angular-material', 'mat-form-field')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">MatFormField</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('angular-material', 'mat-select')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">MatSelect</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">General</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('angular-material', 'mat-button')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">MatButton</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('angular-material', 'mat-icon')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">MatIcon</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Overlays & Feedback</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('angular-material', 'mat-dialog')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">MatDialog</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Progress & Loading</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('angular-material', 'mat-progress-bar')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">MatProgressBar</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Data Display</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('angular-material', 'mat-table')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">MatTable</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('angular-material', 'mat-table-paginator')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">MatTablePaginator</a>
				</wa-tree-item>
			</wa-tree-item>
		</wa-tree-item>
		<wa-tree-item>
			<a (click)="navigateToFramework('jquery-ui')" href="javascript:void(0)" style="cursor:pointer;font-weight:var(--wa-font-weight-semibold);">jQuery UI</a>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Disclosure</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('jquery-ui', 'jquiaccordion')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">JQUIAccordion</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Form Controls</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('jquery-ui', 'jquiauto-complete')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">JQUIAutoComplete</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('jquery-ui', 'jquicheck-box-group')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">JQUICheckBoxGroup</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('jquery-ui', 'jquidate-picker')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">JQUIDatePicker</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('jquery-ui', 'jquiselect-menu')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">JQUISelectMenu</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('jquery-ui', 'jquislider')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">JQUISlider</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('jquery-ui', 'jquispinner')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">JQUISpinner</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Buttons</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('jquery-ui', 'jquibutton')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">JQUIButton</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Overlays & Feedback</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('jquery-ui', 'jquidialog')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">JQUIDialog</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('jquery-ui', 'jquitooltip')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">JQUITooltip</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Interaction</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('jquery-ui', 'jquidraggable')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">JQUIDraggable</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('jquery-ui', 'jquidroppable')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">JQUIDroppable</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('jquery-ui', 'jquiresizable')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">JQUIResizable</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('jquery-ui', 'jquiselectable')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">JQUISelectable</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('jquery-ui', 'jquisortable')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">JQUISortable</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Navigation</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('jquery-ui', 'jquimenu')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">JQUIMenu</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToComponent('jquery-ui', 'jquitabs')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">JQUITabs</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-text-quiet);font-size:var(--wa-font-size-xs);">Progress & Loading</span>
				<wa-tree-item>
					<a (click)="navigateToComponent('jquery-ui', 'jquiprogress-bar')" href="javascript:void(0)" style="cursor:pointer;font-size:var(--wa-font-size-xs);">JQUIProgressBar</a>
				</wa-tree-item>
			</wa-tree-item>
			<wa-tree-item>
				<span style="color:var(--wa-color-brand-normal);font-size:var(--wa-font-size-xs);">Related Plugins</span>
				<wa-tree-item>
					<a (click)="navigateToPlugin('jquery')" href="javascript:void(0)" style="color:var(--wa-color-brand-normal);cursor:pointer;">jQuery</a>
				</wa-tree-item>
				<wa-tree-item>
					<a (click)="navigateToPlugin('easing')" href="javascript:void(0)" style="color:var(--wa-color-brand-normal);cursor:pointer;">Easing Effects</a>
				</wa-tree-item>
			</wa-tree-item>
		</wa-tree-item>
	</wa-tree>
</aside>